/**
 * resolverComPrioridade — valor vindo de broadcast (Realtime) tem prioridade
 * sobre o valor carregado do banco no fetch inicial. Usado pelos flags de
 * temas sazonais e da Batalha de Vibes, que chegam por dois caminhos
 * (fetch inicial via configuracoesService + broadcast `cmd: update_settings`).
 */
export function resolverComPrioridade<T>(broadcast: T | null, db: T): T {
  return broadcast !== null ? broadcast : db;
}
